<template>
  <div class="time-picker">
    <single-select 
      v-model="internalValue"
      :disabled="disabled"
      :placeholder="disabled ? 'Closed' : placeholder"
    >
      <el-option v-for="time in times" :key="time" :label="time" :value="time" />
    </single-select>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import dayjs from '@/helpers/dayjs'

export default defineComponent({
  name: 'TimePicker',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: 'Time...',
    },

    modelValue: {
      type: String,
      default: '',
    },
  },

  emits: ['update:modelValue'],

  computed: {
    internalValue: {
      get(): string {
        return this.modelValue
      },
      set(value: any): any {
        this.$emit('update:modelValue', value)
      },
    },
    /**
     * Generate array of times in AM/PM format and filtered by input value
     */
    times(): Array<string> {
      const format = 'h:mma'
      const start = dayjs().startOf('day')
      const end = start.endOf('day')
      const step = 15
      const times: Array<string> = []
      let currentTime = start

      while (!currentTime.isAfter(end)) {
        times.push(currentTime.format(format))
        currentTime = currentTime.add(step, 'minutes')
      }

      return times
    },
  },
})
</script>
